// extracted by mini-css-extract-plugin
export default {"root":"Sparkles-module__root","progress":"Sparkles-module__progress","button":"Sparkles-module__button","symbol":"Sparkles-module__symbol","sparkle":"Sparkles-module__sparkle"};